import { call, put, takeEvery } from 'redux-saga/effects'
import {
  PublishingLocationsActionType,
  types,
} from '../types/publishingLocations'
import { trace } from '../services/common'
import * as actions from '../actions/publishingLocations'
import * as services from '../services/publishingLocations'

export function* getPublishingLocationsSaga(
  action: PublishingLocationsActionType
) {
  try {
    const list = yield call(services.getPublishingLocations)
    yield put(actions.getPublishingLocationsSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getPublishingLocationsFailure(err.message))
  }
}

export function* publishingLocationsWatcher() {
  yield takeEvery(
    types.GET_PUBLISHING_LOCATIONS__STARTED,
    getPublishingLocationsSaga
  )
}
